import { Card, Chip } from "@mui/joy";
import React, { useEffect } from "react";

interface Event {
  name: string;
  date: string;
  status: string; // e.g., "Register", "Coming Soon", or "Completed"
  statusColor: "success" | "warning" | "danger";
  link?: string; // Optional field for the registration link
}

export default function EventSection({ dark }: { dark: boolean }) {
  const upcomingEvents: Event[] = [
    {
      name: "COE-CNDS, VJTI Internship Recruitment",
      date: "January 4th, 2025",
      status: "Register",
      statusColor: "success",
      link: "/dashboard", // Add your registration link here
    },
  ];

  const pastEvents: Event[] = [];

  useEffect(() => {}, [dark]);

  const renderEvents = (events: Event[], category: string) => {
    return events.length > 0 ? (
      <ul className="space-y-4">
        {events.map((event, index) => (
          <li
            key={index}
            className="flex flex-col sm:flex-row sm:items-center justify-between gap-2"
          >
            <div>
              <p className="font-semibold">{event.name}</p>
              <p className="text-sm">{event.date}</p>
            </div>
            {event.status === "Register" && event.link ? (
              <a
                href={event.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <Chip
                  color={event.statusColor}
                  disabled={false}
                  size="lg"
                  variant="soft"
                  component="button"
                  sx={{
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                >
                  {event.status}
                </Chip>
              </a>
            ) : (
              <Chip
                color={event.statusColor}
                disabled={false}
                size="lg"
                variant="soft"
              >
                {event.status}
              </Chip>
            )}
          </li>
        ))}
      </ul>
    ) : (
      <div className="flex justify-center items-center">
        <p className="text-center font-semibold text-gray-500">
          No {category.toLowerCase()} at the moment.
        </p>
      </div>
    );
  };

  return (
    <section
      id="events"
      className="w-full py-12 md:py-24 lg:py-20 hide-scrollbar"
      style={{ backgroundColor: dark ? "" : "#f9fafb" }}
    >
      <div className="container px-4 md:px-6 mx-auto space-y-16">
        <h2
          className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-8 text-indigo-600 dark:text-indigo-400"
          style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
        >
          Upcoming & Past Events
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          <Card
            className="rounded-lg shadow-lg p-6"
            sx={{
              backgroundColor: dark ? "#1f2937" : "bg-white",
            }}
          >
            <div className="mb-4">
              <h3
                className="text-3xl font-semibold"
                style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
              >
                Upcoming Events
              </h3>
            </div>
            <div>{renderEvents(upcomingEvents, "Upcoming Events")}</div>
          </Card>
          <Card
            className="rounded-lg shadow-lg p-6"
            sx={{
              backgroundColor: dark ? "#1f2937" : "bg-white",
            }}
          >
            <div className="mb-4">
              <h3
                className="text-3xl font-semibold"
                style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
              >
                Past Events
              </h3>
            </div>
            <div>{renderEvents(pastEvents, "Past Events")}</div>
          </Card>
        </div>
      </div>
    </section>
  );
}
